import { CoreDomainSearchStore } from '@wix/domains-search-suite';
import { parseDomain } from '@wix/domains-serverless-interface';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
export const useSearchedDomainBroker = _ref => {
  let enabled = _ref.enabled;
  const submittedDomain = CoreDomainSearchStore.useSubmittedDomain() ?? '';
  const isEligibilityCheckEnabled = enabled && Boolean(submittedDomain);
  const _DomainsApiClient$hoo = DomainsApiClient.hooks.useIsEligibleForBroker({
      domain: submittedDomain
    }, isEligibilityCheckEnabled, {
      useErrorBoundary: false
    }),
    data = _DomainsApiClient$hoo.data;
  return isEligibilityCheckEnabled && data != null && data.isEligible ? parseDomain(submittedDomain).formattedInput : undefined;
};
//# sourceMappingURL=useSearchedDomainBroker.js.map